// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stack-list {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 15px;
}

.vehicle-sold-bg {
  background: var(--successColour);
  color: #fff;
}

.disabled {
  cursor: not-allowed;
}

.filter-container .form-check-label {
  font-size: 0.75rem;
  font-weight: 500;
}

.status-banner {
  border-radius: var(--widgetBorderRadius) var(--widgetBorderRadius) 0 0;
}

.bidders-table td {
  vertical-align: middle;
}

.explain {
  font-size: 0.875rem;
  font-weight: 500;
}

.explain-customer {
  margin-top: 7px;
  font-weight: 700;
}

.explain-contact {
  font-size: 0.75rem;
  font-weight: 500;
}

.bid-placed div {
  line-height: 14px;
  font-size: 12px;
  white-space: nowrap;
}

.sale-name {
  font-size: 13px;
  line-height: 18px;
  display: inline-block;
  font-weight: 500;
}

.cap-line td {
  line-height: 1.25rem;
}

.cap-line .pct {
  padding-left: 5px;
  font-size: 0.75rem;
  line-height: 0.75rem;
  color: #888;
}

.reserve-line td {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  padding-bottom: 10px;
  padding-top: 5px;
}

.sale-status {
  margin-right: 10px;
  padding: 0px 7px;
  line-height: 18px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: bold;
  display: inline-block;
}
.sale-status.sale-status-1 {
  background-color: var(--successColour);
  color: #fff;
}
.sale-status.sale-status-2, .sale-status.sale-status- {
  background-color: #666;
  color: #fff;
}

.filter-container {
  flex: 1 0 24px;
  flex-direction: column;
}

.vrm-plate {
  font-size: 12px;
  background: #FDC72F;
  border: 1px solid #F2C02D;
  border-radius: 4px;
  text-align: center;
  font-weight: 700;
  padding: 0 5px 0 5px;
  display: inline-block;
}

div.make-model-deriv {
  flex-grow: 1;
  padding-right: 10px;
  font-weight: 400;
}

.make-model {
  font-size: 15px;
  font-weight: 600;
  color: var(--textColour);
}

.deriv {
  font-size: 13px;
  font-weight: 500;
  color: #777;
}

.fuel, .trans, .colour, .body {
  font-size: 13px;
  font-weight: 500;
  color: var(--textColour);
}

.odometer {
  font-size: 13px;
  font-weight: 500;
  color: var(--textColour);
}

.vendor-box {
  background-color: #f1f1f1;
  border-left: 1px solid var(--widgetBorderColour);
  padding-left: 10px;
}

textarea {
  font-family: "Courier", serif;
}

.vehicle-sold {
  background-color: var(--dangerColour);
  color: var(--colour3);
  width: 100%;
  padding: 8px;
  text-align: center;
  margin-bottom: 8px;
}

.vendor-customer-name {
  font-weight: 600;
  font-size: 16px;
}

.vendor-contact-name {
  font-weight: 400;
  font-size: 13px;
}

.vendor-contact-email {
  font-weight: 400;
  font-size: 13px;
}

.vendor-contact-phone {
  font-weight: 400;
  font-size: 13px;
}

.small-print {
  font-size: 12px;
  font-weight: 400;
}

.status-name {
  background-color: #0d181c;
  color: #fff;
  padding-bottom: 5px;
  padding-left: 17px;
  padding-right: 5px;
  padding-top: 5px;
  font-weight: 600;
  font-size: 16px;
}

.not-bold {
  opacity: 0.4;
  font-size: 14px;
  padding-top: 5px;
  padding-left: 10px;
}

.status-name.status-color-1, .status-name.status-color- {
  background-color: #FFC107;
}
.status-name.status-color-2 {
  background-color: var(--successColour);
}
.status-name.status-color-3 {
  background-color: var(--dangerColour);
}

.admin-status-name {
  border: 1px solid #ccc;
  border-radius: 4px;
}
.admin-status-name.admin-status-color-1 {
  border-color: var(--successColour);
  color: var(--successColour);
}
.admin-status-name.admin-status-color-2, .admin-status-name.admin-status-color-3, .admin-status-name.admin-status-color-4 {
  border-color: var(--dangerColour);
  color: var(--dangerColour);
}

td.darker, th.darker {
  background-color: rgba(15, 108, 189, 0.05);
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/sale/manage-negotiations/manage-negotiations.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sEAAA;AACF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;AAAF;;AAIE;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AADJ;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AAFF;;AAME;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAJF;AAME;EACE,sCAAA;EACA,WAAA;AAJJ;AAOE;EACE,sBAAA;EACA,WAAA;AALJ;;AASA;EACE,cAAA;EACA,sBAAA;AANF;;AASA;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AANF;;AASA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AANF;;AASA;EACE,yBAAA;EACA,gDAAA;EACA,kBAAA;AANF;;AASA;EACE,6BAAA;AANF;;AASA;EACE,qCAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AANF;;AASA;EACE,gBAAA;EACA,eAAA;AANF;;AASA;EACE,gBAAA;EACA,eAAA;AANF;;AASA;EACE,gBAAA;EACA,eAAA;AANF;;AASA;EACE,gBAAA;EACA,eAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;AANF;;AASA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AANF;;AAWE;EACE,yBAAA;AARJ;AAWE;EACE,sCAAA;AATJ;AAYE;EACE,qCAAA;AAVJ;;AAcA;EAEE,sBAAA;EACA,kBAAA;AAZF;AAcE;EACE,kCAAA;EACA,2BAAA;AAZJ;AAeE;EACE,iCAAA;EACA,0BAAA;AAbJ;;AAiBA;EACE,0CAAA;AAdF","sourcesContent":[".stack-list {\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 15px;\n}\n\n.vehicle-sold-bg {\n  background: var(--successColour);\n  color: #fff;\n}\n\n.disabled {\n  cursor: not-allowed;\n}\n\n.filter-container .form-check-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.status-banner {\n  border-radius: var(--widgetBorderRadius) var(--widgetBorderRadius) 0 0;\n\n}\n\n.bidders-table td {\n  vertical-align: middle;\n}\n\n.explain {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.explain-customer {\n  margin-top: 7px;\n  font-weight: 700;\n}\n\n.explain-contact {\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.bid-placed {\n  div {\n    line-height: 14px;\n    font-size: 12px;\n    white-space: nowrap;\n  }\n}\n\n.sale-name {\n  font-size: 13px;\n  line-height: 18px;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.cap-line td {\n  line-height: 1.25rem;\n}\n\n.cap-line .pct {\n  padding-left: 5px;\n  font-size: 0.75rem;\n  line-height: 0.75rem;\n  color: #888;\n}\n\n.reserve-line {\n  td {\n    font-size: 18px;\n    line-height: 18px;\n    font-weight: 600;\n    padding-bottom: 10px;\n    padding-top: 5px;\n  }\n}\n\n.sale-status {\n  margin-right: 10px;\n  padding: 0px 7px;\n  line-height: 18px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: bold;\n  display: inline-block;\n\n  &.sale-status-1 {\n    background-color: var(--successColour);\n    color: #fff;\n  }\n\n  &.sale-status-2, &.sale-status- {\n    background-color: #666;\n    color: #fff;\n  }\n}\n\n.filter-container {\n  flex: 1 0 24px;\n  flex-direction: column;\n}\n\n.vrm-plate {\n  font-size: 12px;\n  background: #FDC72F;\n  border: 1px solid #F2C02D;\n  border-radius: 4px;\n  text-align: center;\n  font-weight: 700;\n  padding: 0 5px 0 5px;\n  display: inline-block;\n}\n\ndiv.make-model-deriv {\n  flex-grow: 1;\n  padding-right: 10px;\n  font-weight: 400;\n}\n\n.make-model {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--textColour);\n}\n\n.deriv {\n  font-size: 13px;\n  font-weight: 500;\n  color: #777;\n}\n\n.fuel, .trans, .colour, .body {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--textColour);\n}\n\n.odometer {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--textColour);\n}\n\n.vendor-box {\n  background-color: #f1f1f1;\n  border-left: 1px solid var(--widgetBorderColour);\n  padding-left: 10px;\n}\n\ntextarea {\n  font-family: \"Courier\", serif;\n}\n\n.vehicle-sold {\n  background-color: var(--dangerColour);\n  color: var(--colour3);\n  width: 100%;\n  padding: 8px;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.vendor-customer-name {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.vendor-contact-name {\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.vendor-contact-email {\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.vendor-contact-phone {\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.small-print {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.status-name {\n  background-color: #0d181c;\n  color: #fff;\n  padding-bottom: 5px;\n  padding-left: 17px;\n  padding-right: 5px;\n  padding-top: 5px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.not-bold {\n  opacity: 0.4;\n  font-size: 14px;\n  padding-top: 5px;\n  padding-left: 10px;\n}\n\n.status-name {\n\n  &.status-color-1, &.status-color- {\n    background-color: #FFC107;\n  }\n\n  &.status-color-2 {\n    background-color: var(--successColour);\n  }\n\n  &.status-color-3 {\n    background-color: var(--dangerColour);\n  }\n}\n\n.admin-status-name {\n\n  border: 1px solid #ccc;\n  border-radius: 4px;\n\n  &.admin-status-color-1 {\n    border-color: var(--successColour);\n    color: var(--successColour);\n  }\n\n  &.admin-status-color-2, &.admin-status-color-3, &.admin-status-color-4 {\n    border-color: var(--dangerColour);\n    color: var(--dangerColour);\n  }\n}\n\ntd.darker, th.darker {\n  background-color: rgba(15, 108, 189, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
